import { useTokens } from '@/src/hooks';
import { Button } from '@/src/ui-components';
import { ArrowDownUp } from 'lucide-react';
import { useFormContext } from 'react-hook-form';
import { From } from './from';
import { To } from './to';
import { TokenSelectorsFormValues } from './token-selectors.types';

export const TokenSelectors = () => {
  const form = useFormContext<TokenSelectorsFormValues>();

  const tokens = useTokens();

  // Swap tokens only, not the amount as the to.amount is always -1
  const swapTokens = () => {
    const fromToken = form.getValues('from.token');
    const toToken = form.getValues('to.token');

    form.setValue('from.token', toToken);
    form.setValue('to.token', fromToken);
  };

  // Disable button if no tokens are selected
  const isDisabled = !form.getValues('from.token') || !form.getValues('to.token');

  return (
    <>
      <From tokens={tokens} />
      <Button
        type="button"
        variant="outline"
        size="sm"
        onClick={swapTokens}
        className="rounded-full p-2 block mx-auto"
        disabled={isDisabled}
      >
        <ArrowDownUp />
      </Button>
      <To tokens={tokens} />
    </>
  );
};
